export default {"src":"/_next/static/media/img-filecsv.fd231fdf.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};